/**
 * Money is stored everywhere — database, API, UI state — as an integer number of
 * centavos. Never as a float. A till that drifts by a centavo per transaction is a
 * till that cannot be reconciled at the end of a shift.
 */
export const CURRENCY = 'PHP';
export const CURRENCY_SYMBOL = '₱';
/** Parse operator input ("1,250.50", "₱30", "30") into centavos. */
export function parseAmount(input) {
    if (typeof input === 'number')
        return Math.round(input * 100);
    const cleaned = input.replace(/[^\d.-]/g, '');
    if (cleaned === '' || cleaned === '-' || cleaned === '.')
        return 0;
    const value = Number.parseFloat(cleaned);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
}
/** Centavos to a plain decimal number. Use only at the edge — for display or export. */
export function toDecimal(amount) {
    return amount / 100;
}
export function formatMoney(amount, options = {}) {
    const { symbol = true, compactWhole = false } = options;
    const negative = amount < 0;
    const absolute = Math.abs(Math.round(amount));
    const pesos = Math.floor(absolute / 100);
    const centavos = absolute % 100;
    const grouped = pesos.toLocaleString('en-PH');
    const body = compactWhole && centavos === 0 ? grouped : `${grouped}.${String(centavos).padStart(2, '0')}`;
    return `${negative ? '-' : ''}${symbol ? CURRENCY_SYMBOL : ''}${body}`;
}
/**
 * Apply a percentage without accumulating float error.
 * `percent` is a plain percentage: 12 means 12%.
 */
export function percentOf(amount, percent) {
    return Math.round((amount * percent) / 100);
}
/**
 * Split a total across n shares so the parts always sum back to the total.
 * The remainder centavos land on the earliest shares.
 */
export function allocate(total, shares) {
    if (shares <= 0)
        return [];
    const base = Math.floor(total / shares);
    const remainder = total - base * shares;
    return Array.from({ length: shares }, (_, i) => base + (i < remainder ? 1 : 0));
}
export function sumMoney(amounts) {
    return amounts.reduce((total, amount) => total + amount, 0);
}
/**
 * Cash rounding for a drawer that has no 1- and 5-centavo coins.
 * The smallest coin in circulation in the Philippines is ₱0.01, but in practice
 * bakeries round cash to the nearest 25 centavos. Non-cash tenders are exact.
 */
export function roundCash(amount, nearest = 25) {
    if (nearest <= 1)
        return amount;
    return Math.round(amount / nearest) * nearest;
}
/** Denominations of Philippine currency, largest first — drives the cash-count screen. */
export const PHP_DENOMINATIONS = [
    100000, 50000, 20000, 10000, 5000, 2000, // bills: 1000 500 200 100 50 20
    1000, 500, 100, 25, 5, 1, // coins: 10 5 1 0.25 0.05 0.01
];
//# sourceMappingURL=money.js.map